import { render, staticRenderFns } from "./ColumnUsername.vue?vue&type=template&id=0bc3d156&scoped=true"
import script from "./ColumnUsername.vue?vue&type=script&lang=ts"
export * from "./ColumnUsername.vue?vue&type=script&lang=ts"
import style0 from "./ColumnUsername.vue?vue&type=style&index=0&id=0bc3d156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3d156",
  null
  
)

export default component.exports